import { type ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import Seo, { type SeoProps } from "@/seo/Seo";
import { Analytics } from "@/seo/Analytics";
import { BreakingNewsTicker } from "@/components/shared/BreakingNewsTicker";
import { SupportChatWidget } from "@/components/shared/SupportChatWidget";

interface LayoutProps {
  children: ReactNode;
  seo?: SeoProps;
}

export function Layout({ children, seo }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0a101f] text-white font-sans">
      <Seo {...seo} />
      <Analytics />
      <Navbar />
      <BreakingNewsTicker />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <SupportChatWidget />
    </div>
  );
}
